import React from 'react';

function Loader(){
    return (<div className="loading-circle"></div>)
}
export default Loader;